import { Currency, CurrencyProps } from 'models/reusable-parts/currency';
import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export interface SingleAccountProps {
  id: string;
  number: string;
  name: string;
  type: string;
  subtype: string;
  balance: CurrencyProps;
  expenditure: CurrencyProps;
  income: CurrencyProps;
  maturity: number;
  opening: number;
  currency: string;
}

export const SingleAccount = types.model({
  id: types.string,
  number: types.string,
  name: types.string,
  type: types.string,
  subtype: types.string,
  balance: Currency,
  expenditure: Currency,
  income: Currency,
  maturity: types.number,
  opening: types.number,
  currency: types.string,
});

export type SingleAccountSnapshot = SnapshotIn<typeof SingleAccount>;
export type SingleAccountInstance = Instance<typeof SingleAccount>;
